import { render, staticRenderFns } from "./NavMemberGroupChatRecent.vue?vue&type=template&id=d80ddf92&"
import script from "./NavMemberGroupChatRecent.vue?vue&type=script&lang=ts&"
export * from "./NavMemberGroupChatRecent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports